import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Table, TableSkeleton, ModalVariables } from "../../../../../../components";
import { icons } from "../../../../../../icons";
import {Container} from './styles'
import { useParams } from "react-router-dom";
import { useUi } from "../../../../../../context/ui.context";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { clientService } from "../../../../../../api";

const Clients:FC = () => {
  const [rows, setRows] = useState<any[]>([])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam)
  const {viewAlert} = useUi()
  const [paginationData, setPaginationData] = useState<any>()
  const [t] = useTranslation()
  const {userId} = useParams()

  // Modal state
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<string>('')
  const [alertSubTitle, setAlertSubTitle] = useState<string>('')
  const [selectedClient, setSelectedClient] = useState<any>(null)
  const [dataToEdit, setDataToEdit] = useState<any>(null)

  const openModal = (type: string, options?: any) => {
    setModalType(type)
    setAlertTitle(options?.alertTitle || '')
    setAlertSubTitle(options?.alertSubTitle || '')
    setDataToEdit(options?.dataToEdit || null)
    setViewModal(true)
    setActiveAnimation(true)
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }

  const closeModal = (props?: any) => {
    if (modalType === 'universal') {
      _dissociateClient(selectedClient)
    }
    setViewModal(false)
    setActiveAnimation(false)
    updateList()
  }

  const updateList = async () => {
    if(!userId) return
    try{
      const res = await clientService.getUserClients(userId)
      let data = res.data.clients.map((client:any) => {
        return {
        ...client,
        id:client.id,
        long_name:client.display,
        navigate:`/clients-users/clients/${client.id}`,
        roles:client.roles.length > 0 ? client.roles.map((role:any) => role.display_name) : '',
      }})
      setPaginationData(res.data)
      setRows(data)
      setPageLoading(false)

    } catch(e:any){
      if(e?.response?.data?.detail){
        viewAlert({
          severity:'error',
          message:e?.response?.data?.detail
        })
      }
      setPageLoading(true)
    }
  }

  const _dissociateClient = (client: any) => {
    if (!userId || !client?.id) return
    clientService.dissociateClientFromUser(userId, client.id)
      .then((res) => {
        viewAlert({
          severity: 'info',
          message: t("CLIENT_DISSOCIATED_SUCCESS")
        })
        updateList()
      })
      .catch((e) => {
        if (e?.response?.data?.detail) {
          viewAlert({
            severity: 'error',
            message: e?.response?.data?.detail
          })
        }
      })
  }

  useEffect(() => {
    updateList()
  },[page, ordering, pageSize])

  const items = [
    {
      title:t("EDIT_ROLES"),
      id:'2',
      icon:icons.Edit,
      onClick: (item:any) => {
        setSelectedClient(item)
        openModal('edit-roles', {
          alertTitle: t("EDIT_ROLES"),
        })
      },
      divider:false
    },
    {
      title:t("DISSOCIATE_CLIENT"),
      id:'4',
      onClick:(item:any) => {
        setSelectedClient(item)
        openModal('universal', {
          alertTitle: t("DISSOCIATE_CLIENT"),
          alertSubTitle: t("DISSOCIATE_CLIENT_ALERT"),
        })
      },
      icon:icons.MinusDefault,
      divider:false
    },
  ]

  const columns = [
    {
      title:t("ID"),
      key:"id"
    },
    {
      title:t("NAME"),
      key:'long_name'
    },
    {
      title:t("YOUR_ROLES"),
      key:"roles",
      withBackground:true,
    },
    {
      title:"",
      key:'props'
    }
  ]
  return(
    <Container>
      {pageLoading ?
        <TableSkeleton
            rows={10}
            columns={columns?.length || 5}
            columnsData={columns}
          />
      :
        <>
          <div style={{display:'flex', gap:'10px', marginBottom:'10px'}}>
            <Button
              variant="primary"
              size="display"
              onClick={() => openModal('associate-client', {
                alertTitle: t("ASSOCIATE_CLIENT"),
                dataToEdit: { userId },
              })}
              title={t("ASSOCIATE_CLIENT")}
            />
          </div>
          <Table
            columns={columns}
            rows={rows}
            hideCheckbox
            settings={items}
            paginationData={paginationData}
            updateData={updateList}
            loading={pageLoading}
          />
        </>
      }
      <ModalVariables
        id={selectedClient}
        modalType={modalType}
        closeModalCancel={closeModalCancel}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        dataToEdit={dataToEdit}
      />
    </Container>
  )
}

export default Clients
